import type { PropsWithChildren } from "react";
import { ContentDatabaseContext } from "#content-database-context";
import { useContentDatabaseContextValue } from "#content-database-context-value";

export function ContentDatabaseContextProvider({ children }: PropsWithChildren) {
  const value = useContentDatabaseContextValue();
  return (
    <ContentDatabaseContext.Provider value={value}>{children}</ContentDatabaseContext.Provider>
  );
}
